import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Axios from "./axios";
import { WEB_SERVICE_MIMS } from "./constants";

// Saves which report page the clinician opens (clinician is taken from the token in the backend)
const useReportAccess = (page) => {
  const { patientId, software, protocolId, sessionId } = useParams();

  useEffect(() => {
    const reportAccessData = {
      PAGE: page,
      PATIENT_ID: patientId,
      SOFTWARE: software || null,
      PROTOCOL_ID: protocolId || null,
      SESSION_ID: sessionId || null,
    };
    Axios("post", `${WEB_SERVICE_MIMS}/clinicians/report-access`, reportAccessData).catch((error) => {
      console.log("Add report access: ", error);
    });
  }, [page, patientId, software, protocolId, sessionId]);
};

export default useReportAccess;
